<template>
  <div class="pg-kategori-container">
    <!-- Header Row -->
    <div class="pg-kategori-header">
      <div class="header-pernyataan">{{ pernyataanLabel }}</div>
      <div class="header-options">
        <div class="header-option">{{ leftLabel }}</div>
        <div class="header-option">{{ rightLabel }}</div>
      </div>
    </div>

    <!-- Content Rows -->
    <div class="pg-kategori-content">
      <div v-for="(item, index) in items" :key="item.id" class="pg-kategori-item"
        :class="{ 'item-even': index % 2 === 0, 'item-odd': index % 2 === 1 }">

        <!-- Pernyataan -->
        <div class="item-pernyataan" v-sanitize="item.text"></div>

        <!-- Options Container -->
        <div class="item-options">
          <button type="button" class="option-btn" :class="{ selected: answers[item.id] === 1 }"
            @click="updateAnswer(item.id, 1)">
            <div class="option-circle" :class="{ filled: answers[item.id] === 1 }">
              <span v-if="answers[item.id] === 1" class="checkmark">✓</span>
            </div>
          </button>
          <button type="button" class="option-btn" :class="{ selected: answers[item.id] === 0 }"
            @click="updateAnswer(item.id, 0)">
            <div class="option-circle" :class="{ filled: answers[item.id] === 0 }">
              <span v-if="answers[item.id] === 0" class="checkmark">✓</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PGKategoriComponent",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    leftLabel: {
      type: String,
      default: "Tepat",
    },
    rightLabel: {
      type: String,
      default: "Tidak Tepat",
    },
    pernyataanLabel: {
      type: String,
      default: "Pernyataan",
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      answers: { ...this.value },
    };
  },
  methods: {
    updateAnswer(itemId, value) {
      this.$set(this.answers, itemId, parseInt(value));
      this.$emit("input", { ...this.answers });
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.answers = { ...newValue };
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.pg-kategori-container {
  width: 100%;
  margin: 20px 0;
  border: 1px solid #000000;
  border-radius: 5px;
  overflow: hidden;
  background-color: #ffffff;
}

/* Header Styles */
.pg-kategori-header {
  display: flex;
  background-color: #cde1f3;
  border-bottom: 1px solid #000000;
  min-height: 60px;
}

.header-pernyataan {
  flex: 1;
  padding: 16px 20px;
  text-align: center;
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  border-right: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-options {
  display: flex;
  flex-shrink: 0;
  width: 200px;
}

.header-option {
  flex: 1;
  padding: 16px 20px;
  text-align: center;
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  border-right: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-option:last-child {
  border-right: none;
}

/* Content Styles */
.pg-kategori-content {
  display: flex;
  flex-direction: column;
}

.pg-kategori-item {
  display: flex;
  min-height: 80px;
  border-bottom: 1px solid #000000;
  align-items: stretch;
}

.pg-kategori-item:last-child {
  border-bottom: none;
}

.item-even {
  background-color: #ffffff;
}

.item-odd {
  background-color: #ffffff;
}

.item-pernyataan {
  flex: 1;
  padding: 16px 20px;
  border-right: 1px solid #000000;
  display: flex;
  align-items: center;
  line-height: 1.6;
  color: #000000;
  font-size: 15px;
  /* Font size default untuk desktop */
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  text-align: left;
}

.item-options {
  display: flex;
  flex-shrink: 0;
  width: 200px;
}

.option-btn {
  flex: 1;
  height: 100%;
  min-height: 80px;
  border: none;
  border-right: 1px solid #000000;
  background-color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  transition: background-color 0.2s ease;
}

.option-btn:last-child {
  border-right: none;
}

.option-btn:hover {
  background-color: #f8f9fa;
}

.option-btn.selected {
  background-color: #ffffff;
}

.option-circle {
  width: 24px;
  height: 24px;
  border: 2px solid #cbd5e0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}

.option-circle.filled {
  background-color: #4cc5bd;
  border-color: #4cc5bd;
  color: white;
}

.checkmark {
  font-size: 14px;
  font-weight: bold;
  color: inherit;
}

/* Responsive Design */
@media (max-width: 768px) {
  .pg-kategori-header {
    min-height: 50px;
  }

  .header-pernyataan,
  .header-option {
    font-size: 14px !important;
    /* Force override inline styles dari WYSIWYG */
    padding: 12px 16px;
  }

  .header-options {
    width: 160px;
  }

  .item-pernyataan {
    font-size: 14px !important;
    /* Force override inline styles dari WYSIWYG */
    padding: 12px 16px;
    line-height: 1.4;
  }

  /* Override inline styles dari WYSIWYG untuk mobile */
  .item-pernyataan>>>*,
  .header-pernyataan>>>* {
    font-size: inherit !important;
  }

  .item-options {
    width: 160px;
  }

  .option-btn {
    min-height: 70px;
  }

  .pg-kategori-item {
    min-height: 70px;
  }
}

@media (max-width: 600px) {
  .header-options {
    width: 140px;
  }

  .item-options {
    width: 140px;
  }

  .header-pernyataan,
  .header-option {
    font-size: 13px !important;
    /* Force override inline styles dari WYSIWYG */
    padding: 10px 12px;
  }

  .item-pernyataan {
    font-size: 13px !important;
    /* Force override inline styles dari WYSIWYG */
    padding: 10px 12px;
  }

  /* Override inline styles dari WYSIWYG untuk mobile */
  .item-pernyataan>>>*,
  .header-pernyataan>>>* {
    font-size: inherit !important;
  }

  .option-btn {
    min-height: 60px;
  }

  .pg-kategori-item {
    min-height: 60px;
  }

  .option-circle {
    width: 22px;
    height: 22px;
  }

  .checkmark {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .header-options {
    width: 120px;
  }

  .item-options {
    width: 120px;
  }

  .header-pernyataan,
  .header-option {
    font-size: 12px !important;
    /* Force override inline styles dari WYSIWYG */
    padding: 8px 10px;
    line-height: 1.3;
  }

  .item-pernyataan {
    font-size: 12px !important;
    /* Force override inline styles dari WYSIWYG */
    padding: 8px 10px;
    line-height: 1.3;
  }

  /* Override inline styles dari WYSIWYG untuk mobile */
  .item-pernyataan>>>*,
  .header-pernyataan>>>* {
    font-size: inherit !important;
  }

  .option-btn {
    min-height: 55px;
    padding: 4px;
  }

  .pg-kategori-item {
    min-height: 55px;
  }

  .option-circle {
    width: 20px;
    height: 20px;
  }

  .checkmark {
    font-size: 12px;
  }
}

@media (max-width: 360px) {
  .header-options {
    width: 100px;
  }

  .item-options {
    width: 100px;
  }

  .header-pernyataan,
  .header-option {
    font-size: 11px !important;
    /* Force override inline styles dari WYSIWYG */
    padding: 6px 8px;
    line-height: 1.2;
  }

  .item-pernyataan {
    font-size: 11px !important;
    /* Force override inline styles dari WYSIWYG */
    padding: 6px 8px;
    line-height: 1.2;
  }

  /* Override inline styles dari WYSIWYG untuk mobile ultra kecil */
  .item-pernyataan>>>*,
  .header-pernyataan>>>* {
    font-size: inherit !important;
  }

  .option-btn {
    min-height: 50px;
    padding: 2px;
  }

  .pg-kategori-item {
    min-height: 50px;
  }

  .option-circle {
    width: 18px;
    height: 18px;
  }

  .checkmark {
    font-size: 11px;
  }
}

/* Text content styles */
.item-pernyataan>>>p {
  margin: 0 !important;
  line-height: 1.6 !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: auto !important;
  width: 100% !important;
  white-space: normal !important;
  word-break: break-word !important;
}

.item-pernyataan>>>img {
  max-width: 100%;
  height: auto;
  margin: 8px 0;
}

.item-pernyataan>>>ul,
.item-pernyataan>>>ol {
  margin: 8px 0;
  padding-left: 20px;
}

.item-pernyataan>>>* {
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  max-width: 100% !important;
  white-space: normal !important;
  word-break: break-word !important;
  /* Override inline font-size dari WYSIWYG */
  font-size: inherit !important;
}

/* Override font-size untuk semua elemen dengan inline style */
.item-pernyataan>>>span[style*="font-size"],
.item-pernyataan>>>p[style*="font-size"],
.item-pernyataan>>>div[style*="font-size"],
.item-pernyataan>>>[style*="font-size"] {
  font-size: inherit !important;
}
</style>
